import $ from 'jquery';

$(() => {
  $('.to-top a').on('click', (e) => {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 1000);
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/to-top.js
 **/